import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

import { MdwCollapse, MdwFade, MdwSlide } from '@spaces-ui/animations/angular-css';
import { RiveAnimationConfig, MdwRive } from '@spaces-ui/animations/rive';
import { MdwButton } from '@spaces-ui/meadow/components/button';

import { Sample } from '../../components';

interface CheckRow {
  label: string;
  state: number;
  hasHover: boolean;
}

@Component({
  selector: 'app-animations',
  imports: [Sample, MdwRive, MdwCollapse, MdwFade, MdwButton, MdwSlide],
  templateUrl: './animations.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './animations.scss',
})
export class Animations {
  protected readonly isCollapsed = signal(false);
  protected readonly slowCollapsed = signal(false);
  protected readonly horizontalCollapsed = signal(false);
  protected readonly delayedCollapsed = signal(false);

  protected readonly isFaded = signal(false);
  protected readonly slowFaded = signal(false);
  protected readonly showPrimary = signal(true);
  protected readonly skipEnterFaded = signal(false);
  protected readonly skipLeaveFaded = signal(false);

  protected readonly selectedItem = signal<1 | 2 | 3>(1);
  protected readonly items = signal([
    {
      id: 1,
      label: 'Item 1',
    },
    {
      id: 2,
      label: 'Item 2',
    },
    {
      id: 3,
      label: 'Item 3',
    },
  ]);

  protected readonly navDir = signal<'forward' | 'backward'>('forward');
  protected goToItem(itemId: 1 | 2 | 3) {
    const prev = this.selectedItem();
    this.navDir.set(itemId > prev ? 'forward' : 'backward');
    this.selectedItem.set(itemId);
  }

  //#region sample:rive1
  public checkboxAnimationConfig = RiveAnimationConfig.checkMark;
  public data: CheckRow[] = [
    { label: 'Option 1', state: this.checkboxAnimationConfig.states.Unchecked, hasHover: false },
    { label: 'Option 2', state: this.checkboxAnimationConfig.states.Unchecked, hasHover: false },
    { label: 'Option 3', state: this.checkboxAnimationConfig.states.Unchecked, hasHover: false },
    { label: 'Option 4', state: this.checkboxAnimationConfig.states.Unchecked, hasHover: false },
  ];

  public handleMouseEnter(option: CheckRow) {
    option.hasHover = true;
  }

  public handleMouseLeave(option: CheckRow) {
    option.hasHover = false;
  }

  public animateOption(option: CheckRow) {
    option.state =
      option.state === this.checkboxAnimationConfig.states.Checked
        ? this.checkboxAnimationConfig.states.Unchecked
        : this.checkboxAnimationConfig.states.Checked;
  }
  //#endregion
}
